import { API_URL } from '../../../config';
import { axios } from '../../../lib/axios';
import { RegionsResponse, CountriesResponse, BundlesResponse } from '../interface';

const getBundles = async (params: any,partnerWebsiteId: string) : Promise<BundlesResponse>=> {
    return await axios.get(`${API_URL}/bundle`, { params,headers: {
        partnerWebsiteId: partnerWebsiteId
      } });
}
const getCoupons = async (params: any) : Promise<BundlesResponse>=> {
    return await axios.get(`${API_URL}/coupons`, { params: params });
}
const getBundleFilterData = async (params: any) : Promise<BundlesResponse>=> {
    return await axios.get(`${API_URL}/bundle/filter`, { params });
}

const getAllBundlesCustomer = async (params: any): Promise<any> => {
    return await axios.get(`${API_URL}/bundle/allBundlesCustomer`, {
        params,
        headers: { partnerwebsiteid: '69a043250d81d4d36d64ed55' }
    });
}

export {
    getBundles,
    getBundleFilterData,
    getAllBundlesCustomer
};